import * as React from 'react'
import { getLang } from '../helpers'
import { useBookingFormStore } from '../providers/BookingFormStoreProvider'
import {
  buildImageSrcSet,
  getImageFallbackUrls,
  resolveImageAlt,
  selectImageSource,
} from '../utils/responsiveImage'
import Dialog from './Dialog'
import Markdown from './Markdown'

const RoomTypeDialog: React.FunctionComponent = () => {
  const language = useBookingFormStore((state) => state.language)
  const setRoomTypeDialogData = useBookingFormStore((state) => state.setRoomTypeDialogData)
  const roomTypeDialog = useBookingFormStore((state) => state.roomTypeDialog)

  const { data } = roomTypeDialog
  const title = getLang(data?.category, language) || ''
  const imageSrcSet = buildImageSrcSet(data?.variants)

  return (
    <Dialog
      imageAlt={resolveImageAlt(data?.alt, language, title)}
      imageFallbackUrls={getImageFallbackUrls(data?.thumbnail, data?.image)}
      imageHeight={data?.height}
      imageSizes="(min-width: 768px) 704px, calc(100vw - 96px)"
      imageSrcSet={imageSrcSet}
      imageUrl={selectImageSource(data?.variants, data?.thumbnail, data?.image)}
      imageWidth={data?.width}
      onClose={() => setRoomTypeDialogData(null)}
      open={Boolean(data)}
      title={title}
    >
      <Markdown source={getLang(data?.description, language) || ''} />
    </Dialog>
  )
}

export default RoomTypeDialog
